import React, { useEffect, useRef } from 'react';
import type { SgwtSplashScreenHTMLElement } from '@sgmo/shared';

export const SplashScreen: React.FC = () => {
  return <sgwt-splash-screen />;
};
